<app-nav-bar></app-nav-bar>
<app-dashboard-bar></app-dashboard-bar>

<div class="settings_page container flex">
  <div class="side_tabs-container">
    <app-side-settings></app-side-settings>
  </div>

  <div class="right_side-container">
    <div class="right_side">
      <div class="right_side-title">Change Password</div>
    </div>
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="submitPasswordChange()"
      class="edit_profile flex column"
    >
      <div class="input_container">
        <label>Current Password</label>
        <input
          (change)="currentPasswordInput($event)"
          formControlName="CurrentPassword"
          type="password"
        />
        <p
          *ngIf="
            passwordForm.controls.CurrentPassword.touched && !isOldPassword
          "
          class="input-error"
        >
          Your current password is incorrect.
        </p>
        <ng-container
          *ngIf="
            passwordForm.controls.CurrentPassword.invalid &&
            (passwordForm.controls.CurrentPassword.touched ||
              passwordForm.controls.CurrentPassword.dirty)
          "
        >
          <p
            *ngIf="passwordForm.controls.CurrentPassword.errors?.required"
            class="input-error"
          >
            Password is required
          </p>

          <p
            *ngIf="
              passwordForm.controls.CurrentPassword.hasError('invalidPassword')
            "
            class="input-error"
          >
            Invalid Password(Password must be 8-20 alphanumeric characters, must
            contain uppercase ,lowercase, special character.)
          </p>
        </ng-container>
      </div>
      <div class="input_container">
        <label>New Password</label>
        <input formControlName="Password" type="password" />
        <ng-container
          *ngIf="
            passwordForm.controls.Password.invalid &&
            (passwordForm.controls.Password.touched ||
              passwordForm.controls.Password.dirty)
          "
        >
          <p
            *ngIf="passwordForm.controls.Password.errors?.required"
            class="input-error"
          >
            Password is required
          </p>
          <p
            *ngIf="passwordForm.controls.Password.hasError('invalidPassword')"
            class="input-error"
          >
            Invalid Password(Password must be 8-20 alphanumeric characters, must
            contain uppercase ,lowercase, special character.)
          </p>
        </ng-container>
      </div>
      <div class="input_container">
        <label>Confirm Password</label>
        <input formControlName="ConfirmPassword" type="password" />
        <ng-container
          *ngIf="
            passwordForm.controls.ConfirmPassword.invalid &&
            (passwordForm.controls.ConfirmPassword.touched ||
              passwordForm.controls.ConfirmPassword.dirty)
          "
        >
          <p
            *ngIf="passwordForm.controls.ConfirmPassword.errors?.required"
            class="input-error"
          >
            Confirm Password is required
          </p>
          <p
            *ngIf="
              passwordForm.controls.ConfirmPassword.hasError(
                'confirmedValidator'
              )
            "
            class="input-error"
          >
            Passwords do not match.
          </p>
        </ng-container>
      </div>
      <div class="btn_container">
        <button type="submit" class="start_pan_red45">
          Change My Password
        </button>
      </div>
    </form>
  </div>
</div>
